import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import { Add, Edit, GetAll, Remove } from '../../../configurations/crud/doctorsFastNoteCurd'
import { MdDelete, MdErrorOutline } from 'react-icons/md'
import { useToast } from '../../controls/Toast/ToastService'
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5'
import LoadingContainer from '../../controls/LoadingContainer'
import Empty from '../../controls/Empty'
import { RiEditBoxFill } from 'react-icons/ri'
import PagingEmpty from '../../controls/PagingEmpty'
import { CiLocationArrow1 } from 'react-icons/ci'
import DeleteFastNoteModal from './DeleteFastNoteModal'
import AddFastNoteModal from './AddFastNoteModal'
import EditFastNoteModal from './EditFastNoteModal'
import Card from '../../controls/Card'
import useGlobalLoader from '../../../configurations/useGlobalLoader'


export default function ViewFastNotes() {
  const { start, end } = useGlobalLoader()
  const [FastNotesData, setFastNotesData] = useState([])
  const [loding, setLoding] = useState(false)
  const toast = useToast()
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)

  const [editData, setEditData] = useState({
    id: 0,
    note: "",
    priority: "0",
  })

  useEffect(() => {
    GetFastNotes()
  }, [])

  const GetFastNotes = () => {
    setLoding(true)
    start()
    GetAll().then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setFastNotesData(mdata.data)
      } else {
        setFastNotesData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setFastNotesData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const AddFastNote = (param, setValues) => {
    setLodingCrud(true)
    start()
    Add(param).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setValues({
          note: "",
          priority: "0",
        })
        setIsOpenAdd(false)
        GetFastNotes()
        toast.open("FastNote added successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const EditFastNote = (param, setValues) => {
    setLodingCrud(true)
    start()
    Edit(param).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setValues({
          id: 0,
          note: "",
          priority: "0",
        })
        setIsOpenEdit(false)
        GetFastNotes()
        toast.open("FastNote updated successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const DeleteFastNote = (id) => {
    setLodingCrud(true)
    start()
    Remove(id).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setIsOpenDelete(false)
        GetFastNotes()

        toast.open("FastNotes deleted successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }
  return (
    <Container title={"Manage Fast Notes"}>
      <div className='w-full'>
        <Card title={"Manage Fast Notes"} isBorder={true}>
          <div className='flex flex-col'>

            <div className='flex w-20'>
              <button onClick={() => setIsOpenAdd(!isOpenAdd)} className='btn-success my-2 mr-2'>New</button>
            </div>
            <PagingEmpty count={FastNotesData.length}>
              <div class="relative overflow-x-auto">
                {
                  !loding ?
                    FastNotesData.length > 0 ?
                      <table class="border w-full text-sm text-left rtl:text-right text-gray-500">
                        <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                          <tr>
                            <th scope="col" class="px-6 py-3">
                              <div class="flex items-center">
                                <input id="checkbox-all" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600  focus:ring-2 " />
                                <label for="checkbox-all" class="sr-only">checkbox</label>
                              </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                              #
                            </th>
                            <th scope="col" class="px-6 py-3">
                              Note
                            </th>
                            <th scope="col" class="px-6 py-3">
                              Priority
                            </th>
                            <th scope="col" class="px-6 py-3">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {FastNotesData.map((item, index) =>
                            <tr class="bg-white border-b hover:bg-gray-100 ">
                              <td class="w-4 px-6 py-2">
                                <div class="flex items-center">
                                  <input id="checkbox-table-search-1" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 focus:ring-2 " />
                                  <label for="checkbox-table-search-1" class="sr-only">checkbox</label>
                                </div>
                              </td>
                              <td class="px-6 py-2">
                                {index + 1}
                              </td>
                              <td class="px-6 py-2">
                                {item.note}
                              </td>
                              <td class="px-6 py-2">
                                {item.priority}
                              </td>
                              <td class="flex items-center px-6 py-2 sm:w-20">
                                <button onClick={() => { setEditData(item); setIsOpenEdit(!isOpenEdit) }} type="button" class="cursor-pointer text-2xl  text-sky-500 hover:underline mr-1 p-1 hover:bg-gray-200 hover:rounded-lg" title='Edit'><RiEditBoxFill /></button>
                                <button onClick={() => { setEditData(item); setIsOpenDelete(!isOpenDelete) }} type="button" class="cursor-pointer ml-3 text-2xl  text-red-600 hover:underline mr-1 p-1 hover:bg-gray-200 hover:rounded-lg" title='Delete'><MdDelete /></button>
                              </td>
                            </tr>
                          )}

                        </tbody>
                      </table>
                      : <Empty>
                        No Items Found.
                      </Empty>
                    : <LoadingContainer />
                }
                <EditFastNoteModal isOpen={isOpenEdit} setIsOpen={setIsOpenEdit} editData={editData} EditFastNote={EditFastNote} loding={lodingCrud} />
                <AddFastNoteModal AddFastNote={AddFastNote} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />
                <DeleteFastNoteModal DeleteFastNote={DeleteFastNote} isOpen={isOpenDelete} setIsOpen={setIsOpenDelete} loding={lodingCrud} id={editData.id} name={editData.note} />
              </div>
            </PagingEmpty>
          </div>
        </Card>
      </div>

    </Container>




  )
}
